"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marshallKey = void 0;
var tslib_1 = require("tslib");
var isKey_1 = require("./isKey");
var marshallItem_1 = require("./marshallItem");
function marshallKey(schema, input, indexName) {
    var e_1, _a;
    var marshalled = {};
    try {
        for (var _b = tslib_1.__values(Object.keys(schema)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var propertyKey = _c.value;
            var fieldSchema = schema[propertyKey];
            if ((0, isKey_1.isKey)(fieldSchema, indexName)) {
                var _d = fieldSchema.attributeName, attributeName = _d === void 0 ? propertyKey : _d;
                var value = (0, marshallItem_1.marshallValue)(fieldSchema, input[propertyKey]);
                if (value) {
                    marshalled[attributeName] = value;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return marshalled;
}
exports.marshallKey = marshallKey;
